import { createAction, props } from '@ngrx/store';
import { Account } from 'app/core/models/account.model';
import { Expiry } from 'app/pages/security/change/expiry.model';

import { TwoFADevice } from '../../pages/security/twostepverification/model/device.model';
import { TwoFaClientPassword, TwoFaClient } from '../model/twofa-client.model';
import { UserInfo } from '../model/user-info.model';
import { SubAccount } from '../model/sub-account';

export const userLoggedin = createAction('[UserLoggedin List/API] Retrieve User loggedin info Success', props<{ user: Account | null }>());

export const updateUserLanguage = createAction('[User] Update user language', props<{ lang: string }>());

export const retrievedPasswordExpirationConfig = createAction(
  '[Expiration Password] Retrieve Expiry Password configuration',
  props<{ expiryConfig: Expiry | null }>()
);

export const updatePasswordExpirationConfig = createAction(
  '[Expiration Password] Update Expiry Password configuration',
  props<{ expiryConfig: Expiry | null }>()
);

export const retrievedTwoFaInfos = createAction(
  '[TWOFA Status] Retrieve Two factor status',
  props<{ status: boolean | null; device?: TwoFADevice }>()
);

export const updateTwoFaInfos = createAction(
  '[TWOFA Status] Update Two factor status',
  props<{ status: boolean | null; device?: TwoFADevice }>()
);

export const retrieved2faClientStatus = createAction(
  '[TWOFA Client] Retrieved two factor client password',
  props<{ twoFaClientStatus: TwoFaClient }>()
);
export const retrieved2faClientThirdPartsGrants = createAction(
  '[TWOFA Client] Retrieved two factor client third parts grants',
  props<{ clientThirdPartsGrants: SubAccount }>()
);

export const generated2faClientPwd = createAction(
  '[TWOFA Client] Update two factor client password',
  props<{ twoFaClient: TwoFaClientPassword }>()
);

export const delete2faClientPwd = createAction('[TWOFA Client] Delete two factor client password');

export const retrievedWebMailClientUrl = createAction(
  '[TWOFA Client] Retrieved web mail client url',
  props<{ webMailClientUrl: string }>()
);

export const retrieveduserInfoPecPlus = createAction('[User Info] Retrieved user info pec plus', props<{ userInfoPecPlus: UserInfo }>());

export const retrievedOtpDisplayAvailable = createAction(
  '[Pannello Client] Retrieved otp display available',
  props<{ otpDisplayAvailable: boolean }>()
);
